import { useCallback } from "react";
import { FormikProps } from "formik";

const useTrimContent = (formik: FormikProps<any>) => {
  // const handleTrimOnBlur =
  return useCallback(
    async (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = e.target;
      const trimmedValue = value.trim();
      if (trimmedValue !== value) {
        await formik.setFieldValue(name, trimmedValue);
      }
      formik.handleBlur(e);
    },
    [formik],
  );

  // return { handleTrimOnBlur };
};

export default useTrimContent;
